"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = _reactNative.StyleSheet.create({
  TouchHandler: _objectSpread({
    position: 'absolute',
    width: '20%',
    height: '100%',
    top: 0,
    zIndex: 10
  }, _reactNative.Platform.OS === 'web' ? {
    cursor: 'pointer'
  } : {})
});

var _default = function _default(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'left' : _ref$position,
      _ref$onPress = _ref.onPress,
      onPress = _ref$onPress === void 0 ? function () {} : _ref$onPress;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableWithoutFeedback, {
    onPress: onPress
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.TouchHandler, position === 'left' ? {
      left: 0
    } : {
      right: 0
    }]
  }));
};

exports["default"] = _default;